interface LegendItemProps {
  label: string;
  color: string;
}

export const LegendItem = ({
  label,
  color,
}: LegendItemProps) => {
  return (
    <div className="mx-3 d-flex align-items-center">
      <div className="mr-2" style={{ width: '24px', height: '24px', background: color, borderRadius: '50%' }} />
      <p className="pt-2 text-nowrap">{label}</p>
    </div>
  );
};